import * as React from "react";
import type { StringResolverFunc, Text } from "./formatJSX";
import { formatJSX } from "./formatJSX";

export interface FormatInternalProps<K extends string, T extends Text<K>> {
  text: T;
  placeholders: { readonly [key in K]: JSX.Element | string };
  count?: number;
  wrapper?: (element: string | JSX.Element, index: number) => JSX.Element;
  resolveString: StringResolverFunc<K, T>;
}

export function FormatInternal<K extends string, T extends Text<K>>(
  props: FormatInternalProps<K, T>
): JSX.Element {
  const children = formatJSX(
    props.resolveString,
    props.text,
    props.placeholders,
    props.count
  );
  return (
    <>
      {children.map((child, index) =>
        props.wrapper ? props.wrapper(child, index) : child
      )}
    </>
  );
}
